import React from 'react';

export const adminMenu = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: <i className="fa-solid fa-house-chimney"></i>,
  },
  {
    name: 'Websites',
    url: '/websiteAdmin',
    icon: <i className="fa-solid fa-globe"></i>,
  },
  {
    name: 'Roles',
    url: '/roles',
    icon: <i className="fa-solid fa-chalkboard-user"></i>,
  },
  {
    name: 'Users',
    url: '/users',
    icon: <i className="fa-solid fa-users"></i>,
  },
  {
    name: 'Categories',
    url: '/categories',
    icon: <i className="fa-solid fa-layer-group"></i>,
  },
  {
    name: 'DMCA Files',
    url: '/dmcaFiles',
    icon: <i className="fa-solid fa-folder-open"></i>,
  },
  {
    name: 'Noise Words',
    url: '/noiseWords',
    icon: <i className="fa-solid fa-volume-high"></i>,
  },
  {
    name: 'Manual Search',
    url: '/manualSearch',
    icon: <i className="fa-solid fa-magnifying-glass"></i>,
  },
  {
    name: 'Reports',
    url: '/reports',
    icon: <i className="fa-solid fa-file"></i>,
  },
];

export const superAdminMenu = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: <i className="fa-solid fa-house-chimney"></i>,
  },
  {
    name: 'Websites',
    url: '/websitesSuper',
    icon: <i className="fa-solid fa-globe"></i>,
  },
  {
    name: 'Users',
    url: '/users',
    icon: <i className="fa-solid fa-users"></i>,
  },
  {
    name: 'Organization',
    url: '/organization',
    icon: <i className="fa-solid fa-building-columns"></i>,
  },
  {
    name: 'Server',
    url: '/server',
    icon: <i className="fa-solid fa-server"></i>,
  },

  {
    name: 'Crawl Jobs',
    url: '/crawljobs',
    icon: <i className="fa-brands fa-searchengin"></i>,
  },
  {
    name: 'Hit Count Jobs',
    url: '/hitCountJobs',
    icon: <i className="fa-solid fa-calculator"></i>,
  },

  {
    name: 'Noise Words',
    url: '/noiseWords',
    icon: <i className="fa-solid fa-volume-high"></i>,
  },
];

export const userMenu = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: <i className="fa-solid fa-house-chimney"></i>,
  },
  {
    name: 'Websites',
    url: '/websiteAdmin',
    icon: <i className="fa-solid fa-globe"></i>,
  },
  {
    name: 'Categories',
    url: '/categories',
    icon: <i className="fa-solid fa-layer-group"></i>,
  },
  {
    name: 'DMCA Files',
    url: '/dmcaFiles',
    icon: <i className="fa-solid fa-folder-open"></i>,
  },
  {
    name: 'Manual Search',
    url: '/manualSearch',
    icon: <i className="fa-solid fa-magnifying-glass"></i>,
  },
  {
    name: 'Reports',
    url: '/reports',
    icon: <i className="fa-solid fa-file"></i>,
  },
];
